import { Environment } from 'src/environments/type';
import packageJson from '../../package.json';

export const environment: Environment = {
  env: 'development',
  production: true,
  version: packageJson.version,

  domain: '',
  apiUrl: 'https://dev-backend.fast-rocket.de/api',

  sentryDsn:
    'https://a7c9e7c3dda6d258148eab9987884db5@o4507922245091328.ingest.de.sentry.io/4508251373174864',

  SENTRY_AUTH_TOKEN:
    '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',

  defaultLanguage: 'de',

  loginMethod: 'standard',

  saveTableFiltersEnabled: true,

  config: {
    showConfig: true,
    showThemes: false,
    showScale: true,
    showMenuType: false,
    showMenuTheme: false,
    showColorScheme: true,
    showInputStyle: false,
    showRippleEffect: false,
    themeName: 'fast-rocket',
    initialColorScheme: 'light'
  },

  /**
   * Defines if the header should be displayed as card
   */
  header: true,

  /**
   * Defines if the footer should be displayed
   */
  footer: true,

  /**
   * Login style
   * Used for changing the appearance of the login, newpassword and verification page
   * Possible values: 'center', 'right', 'left'
   */
  loggedOutStyle: 'right',

  /**
   * Specify how many digits the verification code should consist of.
   */
  verificationCodeLength: 6,

  /**
   * Password valid at (specifies the valid password strength)
   * Possible values: 'weak', 'medium', 'strong'
   */
  passwordValidAt: 'strong',

  /**
   * Password guidelines
   * The defined rules are displayed in each password input and applied as specified.
   */
  passwordStrength: {
    weak: {
      minCharacters: 6,
      oneLowerCase: false,
      oneUpperCase: false,
      oneNumeric: false,
      oneSpecial: false
    },
    medium: {
      minCharacters: 8,
      oneLowerCase: true,
      oneUpperCase: true,
      oneNumeric: false,
      oneSpecial: false
    },
    strong: {
      minCharacters: 10,
      oneLowerCase: true,
      oneUpperCase: true,
      oneNumeric: true,
      oneSpecial: true
    }
  },

  /**
   * Configuration for generic tables
   */
  tableConfiguration: {
    rows: 15,
    rowsPerPageOptions: [15, 30, 60],
    showTableHeader: false,
    scrollHeight: window.screen.width <= 1920 ? '63vh' : 'calc(88vh - 160px)'
  },
  deadlineOffset: {
    days: 1,
    minutes: 1
  }
};
